import { CompanySettingsInterface } from "../interfaces/CompanySettings";

export const defaultCompanySettings: CompanySettingsInterface = {
  companyColorEnum: 0,
  visibilityEnum: 0,
  isManualAppointmentBlock: false,
  isSingleCalendarManagement: false,
};
